import React, { useEffect, useCallback } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

export default function Lightbox({ images, index, setIndex, onClose }) {
  const prev = useCallback(
    () => setIndex((i) => (i - 1 + images.length) % images.length),
    [images, setIndex]
  );
  const next = useCallback(
    () => setIndex((i) => (i + 1) % images.length),
    [images, setIndex]
  );

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") prev();
      if (e.key === "ArrowRight") next();
    };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [prev, next, onClose]);

  if (images == null || index == null) return null;

  return (
    <div className="fixed inset-0 z-[100] bg-[#2E2621]/95 backdrop-blur-sm flex items-center justify-center p-4 animate-[fadeIn_.3s_ease]">
      <button
        onClick={onClose}
        className="absolute top-5 right-5 w-11 h-11 rounded-full bg-[#FAF5EF]/10 hover:bg-[#B0603F] text-[#FAF5EF] flex items-center justify-center transition-colors"
      >
        <X size={22} />
      </button>

      <button
        onClick={prev}
        className="absolute left-4 md:left-8 w-12 h-12 rounded-full bg-[#FAF5EF]/10 hover:bg-[#B0603F] text-[#FAF5EF] flex items-center justify-center transition-colors"
      >
        <ChevronLeft size={26} />
      </button>

      <img
        src={images[index]}
        alt=""
        className="max-h-[85vh] max-w-[85vw] object-contain rounded-lg shadow-2xl"
      />

      <button
        onClick={next}
        className="absolute right-4 md:right-8 w-12 h-12 rounded-full bg-[#FAF5EF]/10 hover:bg-[#B0603F] text-[#FAF5EF] flex items-center justify-center transition-colors"
      >
        <ChevronRight size={26} />
      </button>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 font-body text-sm tracking-wide-2 text-[#E7D8C6]">
        {index + 1} / {images.length}
      </div>
    </div>
  );
}
